/**
 * @description 自动import导入所有 api 模块
 */

const files = require.context('../api/', false, /\.js$/)
const modules = {}
files.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default modules



// WEBPACK FOOTER //
// ./src/utils/api.js